import { withTranslation, I18nextProvider } from 'react-i18next';

const TranslationProvider = I18nextProvider;

export {
    withTranslation,
    TranslationProvider
};
